import React, { useState, useEffect } from 'react';
import './ExchOddButton.scss';
import lockIcon from '../../assets/images/sportsbook/lock.svg';

type PropType = {
  mainValue: any;
  disable?: boolean;
  oddType: 'back-odd' | 'lay-odd';
  onClick?: () => void;
};

const ExchMobOddButton: React.FC<PropType> = (props) => {
  const { mainValue, disable, oddType, onClick: onclicking } = props;
  const [currentValue, setCurrentValue] = useState<number>(null);
  const [classes, setClasses] = useState<string>('mob-exch-odd-button');
  const [timer, setTimer] = useState(null);
  const mainValprecision: number = 2;

  const oddValueChanged = () => {
    clearTimeout(timer);
    const chVal = mainValue;
    if (chVal) {
      const cVal = currentValue;
      setCurrentValue(chVal);
      let showAnimation = true;
      if (showAnimation) {
        if (cVal && chVal !== cVal) {
          let odType =
            oddType === 'back-odd' ? 'odd-change-back' : 'odd-change-lay';
          if (!classes.includes(odType)) setClasses(classes + ' ' + odType);
          setTimer(
            setTimeout(
              () => setClasses(classes.replace(' ' + odType, '')),
              5000
            )
          );
        }
      }
    }
  };

  useEffect(() => oddValueChanged(), [mainValue]);

  return (
    <span className="mob-exch-odd-view">
      {mainValue ? (
        <div
          className={
            disable ? `${oddType} disabled ` + classes : `${oddType} ` + classes
          }
          onClick={() => onclicking()}
        >
          <div className="mob-exch-odd-button-content">
            <div className="price">
              {Number.isNaN(Number(mainValue)) ? (
                <br></br>
              ) : (
                Number(mainValue).toFixed(mainValprecision)
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={`disabled-btn ` + classes}>
          <img
            className="lock-icon"
            slot="icon-only"
            src={lockIcon}
            alt="lock"
          />
        </div>
      )}
    </span>
  );
};

export default ExchMobOddButton;
